module.exports = __webpack_public_path__ + "img/third-two.04e8813e.png";